import {
  CookiePolicyContent,
  sharedContact,
  sharedSections,
} from './cookie-policy-shared.constants'

export const cookiePolicyUSContent: CookiePolicyContent = {
  title: 'Cookie Policy (US)',
  introduction:
    "This policy sets out information about Travelport's (&quot;<strong>We</strong>&quot; or &quot;<strong>us</strong>&quot; in this policy) use of cookies on our website at 'mmp.travelport.com' (the &quot;<strong>Website</strong>&quot;). It explains what cookies are and why we use them, as well as your rights to control our use of them.",
  sections: [
    sharedSections.whatIsACookie,
    sharedSections.whatCookiesDoesTPUse,
    sharedSections.howToManageCookies,
    sharedSections.removingCookies,
    sharedSections.blockingCookies,
    {
      title: 'How long will cookies stay on my device?',
      paragraphs: [
        'The length of time a cookie will stay on your computer or mobile device depends on whether it is a &quot;persistent&quot; or &quot;session&quot; cookie. <strong>Persistent cookies</strong> are cookies saved on your computer that are not deleted automatically when you quit your browser, unlike a <strong>session cookie</strong>, which is deleted when you quit your browser.',
      ],
    },
    sharedSections.updatesToPolicy,
  ],
  contact: sharedContact,
}
